import PageContainer from '../../common/components/PageContainer';
import { TransactionsTable } from '../../components/transactions/transactionsTable';
import { spacing, primitiveColors } from '../../theming';
import { useMedia } from '../../hooks/useMediaQuery';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import classes from './style.module.scss';

const { Title } = Typography;

export default function Transactions() {
    const { isSmallDevice, isExtraSmallDevice } = useMedia();
    const { t } = useTranslation(['transactions']);

    return (
        <div>
            <Title className={classes.title}>{t('title')}</Title>
            <PageContainer
                style={{
                    padding: isExtraSmallDevice
                        ? `${spacing[4]} ${spacing[3]}`
                        : isSmallDevice
                          ? `${spacing[6]} ${spacing[4]}`
                          : spacing[6],
                    backgroundColor: primitiveColors.gray0,
                }}
            >
                <Title className={classes.subtitle}>{t('subtitle')}</Title>
                <TransactionsTable />
            </PageContainer>
        </div>
    );
}
